export var ToolKind;
(function (ToolKind) {
    ToolKind["Note"] = "note";
    ToolKind["Layer"] = "layer";
    ToolKind["Exit"] = "exit";
    ToolKind["Inliner"] = "inliner";
})(ToolKind || (ToolKind = {}));
// @deprecated ?
export var DefaultStep;
(function (DefaultStep) {
    DefaultStep["Success"] = "success";
    DefaultStep["Failure"] = "failure";
    DefaultStep["Main"] = "main";
})(DefaultStep || (DefaultStep = {}));
//# sourceMappingURL=tool.types.js.map